import mitt from "mitt"
// Global event bus to emit payload between components
const emitter = mitt()
const $eventHub = {
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit
}

export const useEventHub = (): {
  $on: (event: string, callback: (...args: any[]) => void) => void
  $off: (event: string, callback: (...args: any[]) => void) => void
  $emit: (event: string, ...args: any[]) => void
} => {
  return $eventHub
}
